// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__jOJ1e","col":"Table_col__1mPCb","fulfillmentStatus":"Table_fulfillmentStatus__2po0E","emailCol":"Table_emailCol__fksgN"};